import React from "react";
import Invite from "./Invite";
import { Grid } from "@mui/material";
import Link from "next/link";
const InvitesReceived = ({
  myInvites,
  hasReceivedInvites,
  fetchInviteData,
}) => {

  return (
    <section className="container--dashboard_section invites_section" aria-label="Invites Received">
      {hasReceivedInvites && (
        <>
          <Grid
            container
            direction="row"
            justifyContent="flex-start"
            className=""
            alignItems="center">
            {myInvites.map((theInvite, index) => (
            <Link
              style={{cursor:'pointer'}}
              href={"publicteam/"+theInvite?.Team?.public_team_id}
              legacyBehavior
              aria-label="Go to Team"
              > 
              <Grid style={{cursor:'pointer',padding:"5px"}} item key={index}>
            <Invite
              inviteData={theInvite}
              key={`${theInvite.Team?.title}${theInvite.Team?.User.fullname}`}
              inviteType="received"
              fetchInviteData={fetchInviteData}
            />
            </Grid>
          </Link>
            ))}
          </Grid>
        </>
      )}
      {!hasReceivedInvites && (
        <h2 className="header header--section_title header-left" aria-label="No Invites Received">
          You do not have any current invatations
        </h2>
      )}
    </section>
  );
};

export default InvitesReceived;
